import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { FiHome } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRealEstateByUserId,
  getRealEstateData
} from 'redux/realEstateSlice';
import AlternativeModalButtonsContainer from 'sites/common/AlternativeModalButtonsContainer';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import Select from 'react-select';
import messageHandler from 'utils/messageHandler';

const AddBranchOfficeModal = ({
  show,
  setShow,
  userLogged,
  setBranchOfficesUser,
  branchOfficesUser
}) => {
  const branchOffices = useSelector(
    state => state.realEstate.branchOfficesArray
  );
  const realEstate = useSelector(state => state.realEstate.realEstate);

  const dispatch = useDispatch();

  const [selectedBranchOffice, setSelectedBranchOffice] = useState('');

  useEffect(() => {
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  useEffect(() => {
    realEstate.id && dispatch(getRealEstateData(realEstate.id));
  }, [realEstate]);

  const handleSelectBranchOffice = selectedOption => {
    const branchOffice = branchOffices.find(
      branch => branch.id === selectedOption.value
    );

    if (!branchOffice)
      return messageHandler('error', 'No se pudo agregar la sucursal');

    setSelectedBranchOffice({
      branchOfficeId: branchOffice.id,
      branchOfficeName: branchOffice.branch_office_name,
      branchOfficeAddress: branchOffice.address,
      active: true
    });
  };

  const handleAddBranchOffice = () => {
    setBranchOfficesUser(prev => [...prev, selectedBranchOffice]);
    setShow(false);
  };

  const options = branchOffices
    ? branchOffices
        .filter(
          branch =>
            !branchOfficesUser.some(user => user.branchOfficeId === branch.id)
        )
        .map(branch => ({
          value: branch.id,
          label: branch.branch_office_name
        }))
    : [];

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header>
        <Modal.Title>Añadir Sucursal</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>
            <FiHome /> Sucursal
          </Form.Label>
          <Select
            onChange={handleSelectBranchOffice}
            options={options}
            isSearchable={false}
            placeholder="-- Seleccionar Sucursal --"
            value={options.find(
              option => option.value === selectedBranchOffice.branchOfficeId
            )}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <AlternativeModalButtonsContainer>
          <ButtonClose
            funcion={() => setShow(false)}
            text="Cerrar"
            variant="secondary"
          />
          <ButtonAccept funcion={handleAddBranchOffice} text="Añadir" />
        </AlternativeModalButtonsContainer>
      </Modal.Footer>
    </Modal>
  );
};

AddBranchOfficeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  userLogged: PropTypes.object,
  setBranchOfficesUser: PropTypes.func.isRequired,
  branchOfficesUser: PropTypes.array.isRequired
};

export default AddBranchOfficeModal;
